import ReactDOM from "react-dom/client";
import "aos/dist/aos.css";
import AOS from "aos";

export const replaceHydrateFunction = () => {
    return (element, container) => {
      const root = ReactDOM.createRoot(container)
      root.render(element)
    }
}

export const onClientEntry = () => {
    AOS.init({
        once: true,
        duration: 700,
        easing: "ease-out-cubic",
    });
};

export const onRouteUpdate = () => {
    AOS.refresh();
};
